import { observer } from "mobx-react-lite";

import { formatPrice } from "../../common/utils";
import Button from "../../components/Button";
import Divider from "../../components/Divider";
import cartStore from "../../stores/cart/cartStore";
import deliveryFeeStore from "../../stores/deliveryFeeStore";
import promotionStore from "../../stores/promotionStore";
import theme from "../../themes/theme";

const MiniCartGoToCart = () => {
   const cartSummaryBeforeDiscount = cartStore.getCartTotalBeforeDiscount();
   const cartSummary = cartStore.getCartTotal();
   const deliveryCharge = deliveryFeeStore.currentDeliveryCharge();
   const totalCartSum =
      cartSummary.total +
      cartSummary.recyclingCharge +
      (deliveryCharge?.currentFee?.fee ?? 0) -
      promotionStore.getTotalPromotionDiscountForCart();

   const discountFromM3Promotions = cartSummaryBeforeDiscount.total - cartSummary.total;
   const totalCartDiscount = promotionStore.getTotalPromotionDiscountForCart() + discountFromM3Promotions;

   return (
      <div className="mb-2 w-full px-3 lg:px-4">
         <Divider />
         <div className="flex justify-between p-2">
            <div>Total sum</div>
            <div className="font-bold">{formatPrice(totalCartSum)}</div>
         </div>
         {cartSummary.recyclingCharge > 0 && (
            <div className="flex justify-between px-2 text-sm">
               <div>Inkludert pant</div>
               <div>{formatPrice(cartSummary.recyclingCharge)}</div>
            </div>
         )}
         {theme.deliveryFee.enabled && (
            <div className="mb-4 mt-1 flex justify-between px-2 text-sm">
               <div>Inkludert leveringsgebyr</div>
               <div>{formatPrice(deliveryCharge?.currentFee?.fee)}</div>
            </div>
         )}
         {totalCartDiscount > 0 && (
            <div className="mb-4 mt-1 flex justify-between px-2 text-sm text-promotion">
               <div>Inkludert rabatt</div>
               <div>{`- ${formatPrice(totalCartDiscount)}`}</div>
            </div>
         )}
         <div className="flex justify-center p-2">
            <Button
               to="/checkout/cart"
               onClick={cartStore.hideMiniCart}
               className="w-full"
               data-testid="go-to-cart-button"
               size="full"
            >
               Gå til handlekurv
            </Button>
         </div>
      </div>
   );
};

export default observer(MiniCartGoToCart);
